import React from "react";

const Events: React.FC = () => {
  return <>EVENTS PAGE</>;
};

export default Events;
